// @ts-nocheck

import React, { useEffect, useState } from "react";
import SoftBox from "../../../components/common/softBox";
import SoftTypography from "../../../components/common/softTypography";
import SoftInput from "../../../components/common/softInput";
import SoftButton from "../../../components/common/softButton";
import { useDispatch, useSelector } from "react-redux";
import { editRoom, getRoomById } from "../../../features/room";
import { toast } from "react-toastify";
import { useNavigate, useParams } from "react-router-dom";
import { getRoomTypes } from "../../../features/roomType";

const EditRoom = () => {
  const { id } = useParams<{ id: string }>();
  const { room, status } = useSelector((state: any) => state.room);
  const { roomTypes } = useSelector(state => state.roomType); 

  const dispatch = useDispatch();
  const navigate = useNavigate()
console.log(id,'edit_id');

  const [formData, setFormData] = useState({
    room_number: "",
    room_type: "",
    status: "Available", // Default status
    price: "",
   
    additional_details: "",
  });

  useEffect(() => {
     dispatch(getRoomTypes())
    dispatch(getRoomById(id));
  }, [dispatch, id]);

  useEffect(() => {
    if (status && room?.data) {
      const data = room.data;

      console.log(data,'data');
      console.log(data.status,'data.status');

      
      setFormData({
        room_number: data.room_number,
        room_type: data.room_type,
        status: data.status || "Available",
        price: data.price,
      
        additional_details: data.additional_details,
      });
    }
  }, [status, room]);

  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSubmit = () => {
       

    dispatch(editRoom({ id, updatedRoom: formData }))
      .then((res: any) => {
        toast.success(res.payload.message); // Assuming you have a toast function
        navigate('/room'); 

      })
      .catch((err: any) => {
        console.error(err, "error");
      });
  };
console.log(roomTypes,"roomTypes");

  return (
       

    <SoftBox
      display="flex"
      justifyContent="center"
      alignItems="center"
      height="100vh"
      bgColor="white"
      shadow="lg"
      borderRadius="lg"
      p={4}
    >
      {/* Form Container */}
     

      <SoftBox width="100%" maxWidth="400px" mt={10}>
     

        <SoftBox mb={2}>
     

          <SoftTypography variant="h4" fontWeight="bold" textAlign="center">
            Edit Room
          </SoftTypography>
        </SoftBox>
     

        <SoftBox component="form" role="form">
          {/* Room Number Input */}
     

          <SoftBox mb={2}>
     

            <SoftBox mb={1} ml={0.5}>
     

              <SoftTypography component="label" variant="caption" fontWeight="bold">
                Room Number
              </SoftTypography>
            </SoftBox>

            <SoftInput
//   @ts-ignore  

              type="number"
              name="room_number"
              placeholder="Enter the room number"
              value={formData.room_number}
              onChange={handleChange}
            />
          </SoftBox>

          {/* Room Type Dropdown */}
     

          <SoftBox mb={2}>
     

            <SoftBox mb={1} ml={0.5}>
     

              <SoftTypography component="label" variant="caption" fontWeight="bold">
                Room Type
              </SoftTypography>
            </SoftBox>
            <select
              name="room_type"
              value={formData.room_type}
              onChange={handleChange}
              style={{
                width: "100%",
                padding: "10px",
                borderRadius: "5px",
                border: "1px solid #ccc",
              }}
            >
              <option value="">Select Room Type</option>
              {roomTypes && roomTypes.data && roomTypes.data.map((type: any) => (
                <option key={type.id} value={type._id}>
                  {type.name}
                </option>
              ))}
            </select>
          </SoftBox>

          {/* Status Dropdown */}
     

          <SoftBox mb={2}>
     
            
            <SoftBox mb={1} ml={0.5}>
     

              <SoftTypography component="label" variant="caption" fontWeight="bold">
                Status
              </SoftTypography>
            </SoftBox>
            <select
              name="status"
              value={formData.status}
              onChange={handleChange}
              style={{
                width: "100%",
                padding: "10px",
                borderRadius: "5px",
                border: "1px solid #ccc",
              }}
            >
              <option value="Available">Available</option>
              <option value="Occupied">Occupied</option>
              <option value="Maintenance">Maintenance</option>
            </select>
          </SoftBox>

          {/* Price Input */}
     

          <SoftBox mb={2}>
     

            <SoftBox mb={1} ml={0.5}>
     

              <SoftTypography component="label" variant="caption" fontWeight="bold">
                Price
              </SoftTypography>
            </SoftBox>
            <SoftInput
              type="number"
              name="price"
              placeholder="Enter the price"
              value={formData.price}
              onChange={handleChange}
            />
          </SoftBox>



          {/* Additional Details Input */}
          <SoftBox mb={2}>
            <SoftBox mb={1} ml={0.5}>
              <SoftTypography component="label" variant="caption" fontWeight="bold">
                Additional Details
              </SoftTypography>
            </SoftBox>
            <SoftInput
              type="text"
              name="additional_details"
              placeholder="Enter additional details"
              value={formData.additional_details}
              onChange={handleChange}
            />
          </SoftBox>

          {/* Submit Button */}
          <SoftBox mt={4} mb={1}>
            <SoftButton variant="gradient" color="final" fullWidth onClick={handleSubmit}>
              Submit
            </SoftButton>
          </SoftBox>
        </SoftBox>
      </SoftBox>
    </SoftBox>
  );
};

export default EditRoom;
